import React from "react";

const CustomDomainHelpTextModal = ({ siteId, domainName, isOpen, onClose }) => {
  React.useEffect(() => {}, []);

  return (
    <div
      className={`fixed z-50 inset-0 overflow-y-auto ${
        isOpen ? "block" : "hidden"
      }`}
    >
      <div className="flex items-center justify-center min-h-screen p-4 add-domain-popup-1">
        <div className="fixed inset-0 bg-black opacity-50"></div>
        <div className="bg-white rounded-lg p-4 sm:p-8 max-w-2xl w-full mx-auto z-20">
          <h3 className="text-lg font-semibold mb-2 mt-0">
            Connecting a Custom Domain and Setting a Primary Domain
          </h3>
          <p className="text-sm/6 mb-4">
            A <strong>primary domain</strong> is the main domain where your site
            will be served. If you add multiple custom domains, you can set{" "}
            <strong>one</strong> as your primary domain.
          </p>
          <p className="text-sm mb-1">
            <ul>
              <li class="text-sm/6 mb-2">
                If you don’t set any domain as primary, your site will still be
                available but will use your default RocketPages subdomain (e.g.,{" "}
                <strong>yourproject.rocketpagesweb.com</strong>), even if you’ve
                added a custom domain.
              </li>
              <li class="text-sm/6 mb-2">
                When adding a custom domain, you can choose to use it with or
                without <strong>www</strong> (for example,{" "}
                <strong>www.example.com</strong> or <strong>example.com</strong>). The
                version with <strong>www</strong> is technically a subdomain, while
                the version without is called the root or apex domain. Both work
                the same — you can pick whichever you prefer.
              </li>
              <li class="text-sm/6 mb-2">
                It’s best practice to add both versions so your visitors can
                reach your site no matter which one they type.
              </li>
              <li class="text-sm/6 mb-2">
                If you attach a custom domain but don’t validate it, your site
                will continue to use your RocketPages subdomain until the domain
                is validated. We strongly recommend validating your domain to
                ensure secure and reliable delivery.
              </li>
            </ul>
          </p>
          <div>
            <div className="flex justify-end mt-4 sm:mt-6 flex-col sm:flex-row">
              <button
                onClick={onClose}
                className="sm:ml-2 px-4 py-2 border rounded-md hover:bg-gray-200 focus:outline-none focus:ring focus:border-blue-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomDomainHelpTextModal;
